import { centroid, distance, Feature, Position } from "../../../util/turf";
import sortBy from "lodash/sortBy";

export const sortSitesByDistanceToPoint = (sites: Feature[], point: Position) => {
  return sortBy(sites, ({ geometry }) => {
    if (!geometry) return 0;
    const centerOfGeometry = centroid(geometry);
    return distance(centerOfGeometry, point);
  });
};
